var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPolicies1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.779,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ec6e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f0bbb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3140",
    "data-name": "Rectangle 3140",
    width: 80,
    height: 80,
    transform: "translate(16292 1488)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_policies",
    transform: "translate(-16292 -1488)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_policies-2",
    "data-name": "ic_policies",
    transform: "translate(16299.974 1495.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14797",
    "data-name": "Path 14797",
    d: "M0,0H64.053V64.053H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14798",
    "data-name": "Path 14798",
    d: "M15.332,20.39a9.012,9.012,0,0,0,8.694,6.637H36.039a15.018,15.018,0,0,1,14.8,12.45,9.017,9.017,0,1,1-6.1.193,9.012,9.012,0,0,0-8.694-6.637H24.026a14.949,14.949,0,0,1-9.009-3v9.52a9.012,9.012,0,1,1-6.006,0V20.51a9.012,9.012,0,1,1,6.322-.12Zm-3.318-5.376a3,3,0,1,0-3-3A3,3,0,0,0,12.014,15.014Zm0,36.037a3,3,0,1,0-3-3A3,3,0,0,0,12.014,51.051Zm36.037,0a3,3,0,1,0-3-3A3,3,0,0,0,48.051,51.051Z",
    transform: "translate(6.997 1.997)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPolicies1);
export default __webpack_public_path__ + "static/media/ic_policies_1.e33c7314ba0020fea615eb94db3bdaa8.svg";
export { ForwardRef as ReactComponent };